import SEOHead from '@/components/SEOHead';
import Navigation from '@/components/Navigation';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';
import CookieConsent from '@/components/CookieConsent';
import BackToTop from '@/components/BackToTop';

export default function ContactPage() {

  return (
    <div className="min-h-screen bg-white dark:bg-[#0A0A0A] transition-colors duration-300">
      <SEOHead
        title="Contact UI Designs | Free Web Design Quote | Bournemouth"
        description="Get a free web design quote for your Bournemouth, Poole, or Christchurch business. Affordable website design and hosting. Response within 24 hours, no obligation."
        canonical="https://uidesigns.co.uk/contact"
        keywords="contact web designer Bournemouth, free website quote, web design enquiry"
      />
      <Navigation />
      <main className="pt-20">
        <ContactSection />
      </main>
      <Footer />
      <CookieConsent />
      <BackToTop />
    </div>
  );
}
